import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Transl } from './transl.decorator';
import { getLang } from './transl.service';

@Component({
    selector: 'app-transl-locale',
    template: '',
})
// tslint:disable-next-line:component-class-suffix
export class TranslLocale implements OnDestroy {
    locale = 'en-US';
    componentDestroyed$ = new Subject();

    constructor() {
        this.getLocale();
    }

    @Transl()
    getLocale() {
        this.locale = getLang();
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }
}
